import { useState } from "react";

function FandOEdgeModule() {
  const [activeModule, setActiveModule] = useState(null);

  const toggleModule = (index) => {
    setActiveModule(activeModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to F&O Trading",
      content: [
        "Overview of Futures and Options as essential trading instruments.",
        "The F&O market landscape: how it works, participants, and opportunities.",
      ],
    },
    {
      title: "Module 2: Understanding Futures Contracts",
      content: [
        "The core mechanics of Futures contracts: what they are and how they are traded.",
        "Key terms: contract size, margin, and expiry.",
      ],
    },
    {
      title: "Module 3: Futures Trading Strategies",
      content: [
        "Basic strategies: trend-following, breakout trading, and hedging with Futures.",
        "How to align Futures positions with market conditions.",
      ],
    },
    {
      title: "Module 4: Introduction to Options Contracts",
      content: [
        "Understanding Calls and Puts: the foundation of Options trading.",
        "Key terms: strike price, premium, expiration date.",
      ],
    },
    {
      title: "Module 5: Options Trading Strategies",
      content: [
        "Basic strategies: Covered Call, Protective Put, and Naked Put.",
        "The risk-reward profile of each strategy and how to choose the right one.",
      ],
    },
    {
      title: "Module 6: Advanced Options Strategies",
      content: [
        "Advanced strategies: Iron Condor, Butterfly, Straddle, and Strangle.",
        "When and why to use these strategies for higher returns with controlled risk.",
      ],
    },
    {
      title: "Module 7: Using the Greeks for Trading Edge",
      content: [
        "Introduction to Delta, Gamma, Theta, Vega, and Rho.",
        "How to use the Greeks to predict price movements, volatility, and time decay.",
      ],
    },
    {
      title: "Module 8: Risk Management in F&O Trading",
      content: [
        "The importance of risk management: position sizing, stop-loss, and hedging.",
        "Managing risk in leveraged Futures and Options trades.",
      ],
    },
    {
      title: "Module 9: Volatility as Your Trading Edge",
      content: [
        "Understanding market volatility and how to use it in Futures and Options trading.",
        "How implied and historical volatility affect pricing and strategy selection.",
      ],
    },
    {
      title: "Module 10: F&O Hedging Techniques",
      content: [
        "Using Futures and Options together to hedge risk in other positions or portfolios.",
        "Techniques for protecting profits and limiting losses using F&O.",
      ],
    },
    {
      title: "Module 11: Market Sentiment & Timing Your Trades",
      content: [
        "How to gauge market sentiment: sentiment analysis, news, and indicators.",
        "Timing your trades with technical analysis and market conditions.",
      ],
    },
    {
      title: "Module 12: Psychological Edge in F&O Trading",
      content: [
        "Managing emotions: fear, greed, and discipline in trading.",
        "Developing a resilient trading mindset and sticking to your strategy.",
      ],
    },
    {
      title: "Module 13: Backtesting & Strategy Development",
      content: [
        "How to backtest F&O strategies using historical data.",
        "Refining strategies based on backtest results to improve profitability.",
      ],
    },
    {
      title: "Module 14: Advanced Risk-Reward Management",
      content: [
        "Techniques for balancing risk and reward in high-leverage F&O trades.",
        "Setting realistic profit targets and loss limits based on your risk tolerance.",
      ],
    },
    {
      title: "Module 15: Building Your F&O Edge: Personal Trading Plan",
      content: [
        "Creating a custom trading plan based on your risk profile, strategies, and goals.",
        "Continuous improvement: monitoring performance and adjusting strategies as you learn.",
      ],
    },
  ];

  return (
    <div className="container py-5">
      <h1 className="text-center mb-4">The F&O Edge</h1>
      <p className="text-center text-muted mb-5">
        Master the art and science of Futures & Options trading.
      </p>
      <div className="accordion">
        {modules.map((module, index) => (
          <div key={index} className="mb-3">
            <div
              className="p-3 bg-primary text-white d-flex justify-content-between align-items-center"
              onClick={() => toggleModule(index)}
              style={{
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              <h5 className="m-0">{module.title}</h5>
              <span
                style={{
                  fontSize: "18px",
                  transform: activeModule === index ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                ▼
              </span>
            </div>
            {activeModule === index && (
              <div
                className="p-3 bg-light border"
                style={{ borderRadius: "5px" }}
              >
                {module.content.map((item, i) => (
                  <p key={i} style={{ margin: "5px 0", fontSize: "14px" }}>
                    ➤ {item}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FandOEdgeModule;
